export default "__VITE_ASSET__sb4$7ezc__"